var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.2 28.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: #E6E6E6;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        clip-rule: evenodd;\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.3,5.3v18.7c0,.9.7,1.6,1.6,1.6h18.7c.9,0,1.6-.7,1.6-1.6V5.3c0-.9-.7-1.6-1.6-1.6H5c-.9,0-1.6.7-1.6,1.6ZM17.6,24.6V4.8h6c.3,0,.5.2.5.5v18.7c0,.3-.2.5-.5.5h-6ZM16.5,15.2v9.3H5c-.3,0-.5-.2-.5-.5V5.3c0-.3.2-.5.5-.5h11.5v10.4ZM19.3,5.9h3.3c.3,0,.5.2.5.5s-.2.5-.5.5h-3.3c-.3,0-.5-.2-.5-.5s.2-.5.5-.5ZM19.3,8.1h3.3c.3,0,.5.2.5.6s-.2.5-.5.5h-3.3c-.3,0-.5-.2-.5-.5s.2-.6.5-.6ZM20.4,10.3h2.2c.3,0,.5.2.5.5s-.2.6-.5.6h-2.2c-.3,0-.5-.2-.5-.6s.2-.5.5-.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8,15.2h6.5l-2.2,2.2c-.2.2-.2.5,0,.8.2.2.5.2.8,0l3.2-3.2c.2-.2.2-.6,0-.8l-3.1-3.1c-.1-.1-.2-.2-.4-.2s-.3,0-.4.2c-.2.2-.2.6,0,.8l2.2,2.2h-6.5v1.1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.3,
    y: 2.7,
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7,
    y: 10,
    width: 10.4,
    height: 9.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8ab331d18a019845788821bccb5020a4.svg";
export { ForwardRef as ReactComponent };